import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl } from 'react-intl';

import { compareByTitle } from 'shared/helpers/arrays';
import BrandsColumn from './BrandsColumn/BrandsColumn';

import s from './BrandsList.css';

class BrandsList extends Component {
  static propTypes = {
    makes: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    location: PropTypes.shape(),
    subHeadline: PropTypes.shape(),
    routeLocation: PropTypes.shape(),
    transportSlug: PropTypes.string,
  };

  static defaultProps = {
    routeLocation: null,
    subHeadline: null,
    location: null,
    transportSlug: 'avto',
  };

  state = {
    collapsed: true,
  };

  setExpanded = collapsed => {
    this.setState({ collapsed });
  };

  buildBrandLink = slug => {
    const { routeLocation, location, transportSlug } = this.props;

    if (routeLocation && routeLocation.slug) {
      return `/${transportSlug}/${slug}/${routeLocation.slug}/`;
    } else if (location && location.slug) {
      return `/${transportSlug}/${slug}/${location.slug}/`;
    }

    return `/${transportSlug}/${slug}/`;
  };

  createColumns = (arr, columnCount) => {
    const step = Math.round(arr.length / columnCount);
    const biggestColumnCount = step === 0 && arr.length > 0 ? arr.length % columnCount : 0;

    const columns = Array.from(new Array(columnCount), (x, i) => i).map(item =>
      arr.slice(item * step, (item + 1) * step),
    );

    if (biggestColumnCount) {
      arr.slice(-biggestColumnCount).forEach((item, i) => columns[i].push(item));
    }

    return columns;
  };

  render() {
    const { makes } = this.props;
    const brands =
      makes &&
      makes.map(brand => ({
        ...brand,
        link: this.buildBrandLink(brand.slug),
      }));

    const { collapsed } = this.state;
    const perColumn = 6;
    const columnsNum = 5;
    const columnWidth = {
      width: `${100 / columnsNum}%`,
    };

    let showedBrands = brands || [];

    if (collapsed) {
      showedBrands = showedBrands
        .slice()
        .sort((a, b) => -(parseFloat(a.count) - parseFloat(b.count)));

      showedBrands = showedBrands.slice(0, perColumn * columnsNum - 1);
      showedBrands = showedBrands.slice().sort(compareByTitle);
    }

    showedBrands = showedBrands.sort(compareByTitle);

    if (makes) {
      makes.sort(compareByTitle);
    }

    const shouldShowBtn = brands && brands.length && brands.length > perColumn * columnsNum - 1;

    const columns = this.createColumns(showedBrands, columnsNum);

    return (
      <div className={s.root}>
        <div className={s.card}>
          {this.props.subHeadline &&
            <h2 className={s.subHeadline}>
              {this.props.subHeadline}
            </h2>}
          {makes &&
            makes.length > 0 &&
            <div className={s.flexContainer}>
              {columns.map((items, i) =>
                // eslint-disable-next-line react/no-array-index-key
                <div className={s.column} style={columnWidth} key={i}>
                  <BrandsColumn
                    collapsed={collapsed}
                    isLast={i !== columnsNum - 1}
                    handleClick={this.setExpanded}
                    brands={items}
                    shouldShowBtn={shouldShowBtn}
                  />
                </div>,
              )}
            </div>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  locale: globals.locale,
  location: globals.location,
});

export default withStyles(s)(connect(mapStateToProps)(injectIntl(BrandsList)));



// WEBPACK FOOTER //
// ./src/desktop/components/BrandsList/BrandsList.js